import React from "react";
import { Routes, Route } from "react-router-dom";
import Layout from "Layout";
import NonAuthLayout from "Layout/NonAuthLayout";

// Routes
import { publicRoutes, authProtectedRoutes } from "./allRoutes";
import { AuthProtected } from "./AuthProtected";

const Index = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route element={<NonAuthLayout />}>
        {publicRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={route.component}
          />
        ))}
      </Route>

      {/* Auth Protected Routes */}
      <Route
        element={
          <AuthProtected>
            <Layout />
          </AuthProtected>
        }
      >
        {authProtectedRoutes.map((route: any, idx: number) => (
          <Route
            key={idx}
            path={route.path}
            element={route.component}
          />
        ))}
      </Route>
    </Routes>
  );
};

export default Index;
